import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { removeMessageFromMessageBody, toggleModal, toggleModalWithTimer, updateMessages } from 'actions/appAction';
import { updateRecords } from 'actions/historyAction';

import { CHANGE_IDENT_STATUS, ERROR, ERROR_TOAST, INFO, SUCCESS, SUCCESS_TOAST } from 'constants/Constants';
import { AUTH_CLOSE_MESSAGE_URL } from 'constants/UrlConstants';

import { getFullEncodeApiUrl } from 'helpers/api';

import ModalComponent from './ModalComponent';
import { isSoftOrHardServerError } from '../../helpers/utils';
import { InfoPage } from '../common/Layout/InfoPage/InfoPage';

const MESSAGE_CLOSE_ACTION = '/message/close.action';

const removingUnnecessaryMessages = ({ messages, ...props }) => {
    const requests = [];
    const lastIndexArray = messages.length - 1;
    messages.forEach((element, index) => {
        const { expires, messageId, messageType } = element;
        const isTypeMessageError = messageType === ERROR || messageType === ERROR_TOAST;
        const isTypeMessageSuccess = messageType === SUCCESS || messageType === SUCCESS_TOAST;
        const isNotLastElement = lastIndexArray !== index;
        if ((isTypeMessageError || isTypeMessageSuccess) && isNotLastElement) {
            requests.push(
                fetch(getFullEncodeApiUrl(`${props.isAuth ? AUTH_CLOSE_MESSAGE_URL : MESSAGE_CLOSE_ACTION}?messageId=${messageId}&expire${expires}`), {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    body: new URLSearchParams(),
                    headers: { Accept: 'application/json' },
                }),
            );
        }
    });
    if (requests.length > 0) {
        Promise.allSettled(requests)
            .then((responses) => Promise.allSettled(responses.map((r) => r.value.text())))
            .then((res) => {
                if (res.length === lastIndexArray) {
                    props.updateMessages([messages[lastIndexArray]]);
                }
            })
            .catch((err) => {
                console.warn(err);
                return null;
            });
    }
};

const changingStatusHistoryRecord = (props) => {
    const {
        messages: [{ paymentId, status }],
        history: {
            paymentHistory: { payments },
        },
    } = props;

    payments.forEach((records, paymentIndex) => {
        records.records.forEach((record, recordIndex) => {
            if (record.paymentId === paymentId) {
                const newRecord = { ...record };
                newRecord.status = status;
                props.updateRecords(paymentId, status, paymentIndex, recordIndex, newRecord);
            }
        });
    });
};

const MessageBodyService = (props) => {
    const { messages = [], history = {} } = props;

    useEffect(() => {
        if (messages.length === 1 && history?.paymentHistory?.payments.length >= 0 && messages[0]?.paymentId) {
            changingStatusHistoryRecord(props);
        }
        if (messages?.length > 1) {
            removingUnnecessaryMessages(props);
        }
    }, [messages?.length]);

    useEffect(() => {
        if (messages?.length) {
            messages.forEach((message) => showModal(message));
        }
    }, [messages]);

    const showModal = (message) => {
        const { expires, messageId, messageType, value, errorCode } = message;
        const isTypeMessageError = messageType === ERROR || messageType === ERROR_TOAST;
        const isTypeMessageSuccess = messageType === SUCCESS || messageType === SUCCESS_TOAST;
        const isTypeMessageInfo = messageType === INFO;
        const softOrHardBlock = isSoftOrHardServerError(errorCode);

        if (!softOrHardBlock) {
            if (isTypeMessageSuccess || isTypeMessageInfo) {
                props.toggleModalWithTimer(true, value, () => {
                    props.removeMessageFromMessageBody(messageId, expires, props.isAuth);
                    props.toggleModalWithTimer(false);
                });
            }
            if (isTypeMessageError) {
                props.toggleModal(
                    true,
                    <ModalComponent canCloseModal={false} isVerticalCentered key={messageId}>
                        <InfoPage
                            insideModalComponent
                            animatedIconFail
                            mainText={value}
                            primaryButtonType="button"
                            primaryButtonCaption={props.goBack}
                            primaryButtonOnClick={() => {
                                props.toggleModal(false);
                                props.removeMessageFromMessageBody(messageId, expires, props.isAuth);
                            }}
                        />
                    </ModalComponent>,
                );
            }
        }
        return null;
    };

    return null;
};

MessageBodyService.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            messageId: PropTypes.string.isRequired,
            messageType: PropTypes.oneOf([SUCCESS, INFO, ERROR, SUCCESS_TOAST, CHANGE_IDENT_STATUS, ERROR_TOAST]).isRequired,
            expires: PropTypes.number,
        }),
    ),
};

const mapStateToProps = (state) => {
    return {
        isAuth: state.auth.authUser,
        messages: state.app.messageBody,
        history: state.history,
        goBack: state.messages.pageMessages.goBack,
    };
};

export default connect(mapStateToProps, { removeMessageFromMessageBody, updateMessages, updateRecords, toggleModal, toggleModalWithTimer })(MessageBodyService);
